module.exports = __webpack_public_path__ + "static/media/galerija_2017 (2).1a82af91.jpg";